<ds-app-wrapper
  [menu]="location.path().includes('sidebar/demo') ? demoMenu : menu"
>
  <ds-breadcrumbs baseUrl="/" baseLabel="Design System" fxFlex="0 0 auto" />
  <div fxFlex="1 1 auto" class="flex-page-container">
    <router-outlet />
  </div>
</ds-app-wrapper>
